<template>
  <div class="share-box">
    <!-- <img :src="que.banner" alt="" @load="bannerLoad"> -->
    <van-tabs
      v-model="tab_current"
      sticky
      color="#1890FF"
      title-active-color="#1890FF"
      @click.capture="changeHeadTab"
    >
      <van-tab v-for="(item, index) in tabs" :key="index" :title="item.title">
      </van-tab>
    </van-tabs>
    <div
      v-if="tab_current == 0 || tab_current == 1"
      class="posterImg-box"
      :style="{ height: middleHeight + 'px' }"
    >
      <img
        :src="prurl"
        alt="分享图片"
        id="posterIimg"
        :style="{
          height:
            tab_current == 0 && line_color_index == -1 && codeType == 1
              ? '300px'
              : middleHeight + (saveAble ? -40 : -70) + 'px',
          width:
            tab_current == 0 && line_color_index == -1 && codeType == 1
              ? '300px'
              : ' auto'
        }"
        class="poster-img"
        @click="prevImg(prurl)"
        v-if="prurl"
      />
      <div class="read-text" v-if="!saveAble">长按图片保存</div>
      <div class="cover-bg" v-if="showLoading">图片生成中...</div>
      <div v-if="tab_current == 0">
        <div
          class="pic-box"
          id="pic-box"
          :style="{
            height:
              tab_current == 0 && line_color_index == -1 && codeType == 1
                ? '304px'
                : '691px',
            width:
              tab_current == 0 && line_color_index == -1 && codeType == 1
                ? '304px'
                : '489px'
          }"
        >
          <div class="pic-box-wrap">
            <img
              class="cover-img"
              :src="codeType == 1 ? qrcode.code4 : qrcode.code5"
              alt=""
            />
            <img
              v-if="logo && que.enterprise_vip"
              :src="logo"
              class="cover-logo"
              :class="{
                square: codeType == 2,
                active:
                  tab_current == 0 && line_color_index == -1 && codeType == 1
              }"
              alt=""
            />
          </div>
        </div>
      </div>
      <div v-if="tab_current == 1">
        <div class="paint-wrap">
          <div
            class="preview-img-box"
            id="pic-box1"
            :style="{
              background: tabIndex > 1 ? '' : colorLists[bg_color_index].bg
            }"
          >
            <div
              :class="tabIndex > 1 ? 'tall preview-img' : 'preview-img'"
              :id="'pic-box1'"
              :style="{ backgroundImage: `url(${tabBgImgs[tabIndex]})` }"
            >
              <div v-if="tabIndex < 2" :class="`pre${tabIndex}-top`">
                <div :class="`pre${tabIndex}-title`">{{ que.title }}</div>
              </div>
              <div v-if="tabIndex == 1">
                <div class="flex">
                  <img
                    :class="`pre${tabIndex}-avatar`"
                    :src="
                      que.is_owner
                        ? que.owner_avatar
                        : que.join_avatar || que.joiner_avatar
                    "
                    alt=""
                  />
                  <div :class="`pre${tabIndex}-name`">
                    {{
                      que.is_owner
                        ? que.owner_name
                        : que.name || que.joiner_name
                    }}
                  </div>
                </div>
                <div :class="`pre${tabIndex}-invite`">
                  邀请你扫码参与答题~
                </div>
                <div :class="`pre${tabIndex}-qrcode`">
                  <img
                    :class="`pre${tabIndex}-qrcode-out`"
                    :src="codeType == 1 ? qrcode.code1 : qrcode.code2"
                    alt=""
                  />
                  <div
                    v-if="logo && qrcode.code1 && que.enterprise_vip"
                    :class="
                      codeType == 1 ? 'logo code-type1' : 'logo code-type2'
                    "
                  >
                    <img class="logo-icon" :src="logo" alt="" />
                  </div>
                </div>
                <div :class="`pre${tabIndex}-footer`">
                  <img
                    src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-05-31/d17544185bbf53b40af1d87c7f9d0289.png"
                    alt=""
                  />
                  <span>立吉答题丨在线考试问卷调查</span>
                </div>
              </div>
              <div v-if="tabIndex == 0">
                <img
                  :src="que.banner || default_banner"
                  :class="`pre${tabIndex}-banner`"
                  alt=""
                />
                <div :class="`pre${tabIndex}-invite`">
                  <div class="flex">
                    <img
                      :class="`pre${tabIndex}-avatar`"
                      :src="
                        que.is_owner
                          ? que.owner_avatar || que.joiner_avatar
                          : que.join_avatar || que.joiner_avatar
                      "
                      alt=""
                    />
                    <div :class="`pre${tabIndex}-name`">
                      <div class="font500">
                        {{
                          que.is_owner
                            ? que.owner_name
                            : que.name || que.joiner_name
                        }}
                      </div>
                      <div class="f12 gray inname">邀请你扫码参与答题~</div>
                    </div>
                  </div>
                  <div :class="`pre${tabIndex}-qrcode`">
                    <img
                      :class="`pre${tabIndex}-qrcode-out`"
                      :src="codeType == 1 ? qrcode.code1 : qrcode.code2"
                      alt=""
                    />
                    <div
                      v-if="logo && qrcode.code1 && que.enterprise_vip"
                      :class="
                        codeType == 1 ? 'logo code-type1' : 'logo code-type2'
                      "
                    >
                      <img class="logo-icon" :src="logo" alt="" />
                    </div>
                  </div>
                </div>
                <div :class="`pre${tabIndex}-footer`">
                  <img
                    src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-05-31/d17544185bbf53b40af1d87c7f9d0289.png"
                    alt=""
                  />
                  <span>立吉答题丨在线考试问卷调查</span>
                </div>
              </div>
              <div v-if="tabIndex == 2 || tabIndex == 3">
                <div class="flexCenter">
                  <img
                    :class="`pre${tabIndex}-avatar`"
                    :src="
                      que.is_owner
                        ? que.avatar
                        : que.join_avatar || que.joiner_avatar
                    "
                    alt=""
                  />
                  <div :class="`pre${tabIndex}-name`">
                    {{
                      que.is_owner
                        ? que.owner_name
                        : que.name || que.joiner_name
                    }}
                  </div>
                </div>
                <div class="iname">邀请你参加答题测试</div>
                <img
                  v-if="tabIndex == 2"
                  :src="que.banner || default_banner"
                  :class="`pre${tabIndex}-banner`"
                  alt=""
                />
                <div :class="`pre${tabIndex}-title`">{{ que.title }}</div>
                <div :class="`pre${tabIndex}-footer`">
                  <div>
                    <div class="tip1">立吉答题</div>
                    <div class="tip2">长按或扫码参与答题</div>
                  </div>
                  <div :class="`pre${tabIndex}-qrcode`">
                    <img
                      :class="`pre${tabIndex}-qrcode-out`"
                      :src="codeType == 1 ? qrcode.code1 : qrcode.code2"
                      alt=""
                    />
                    <div
                      v-if="logo && que.enterprise_vip"
                      :class="
                        codeType == 1 ? 'logo code-type1' : 'logo code-type2'
                      "
                    >
                      <img class="logo-icon" :src="logo" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-if="tab_current == 2">
      <div class="link-box">
        <div class="link-title" v-if="h5ShareType == 0">
          H5链接<span class="link-tip"
            >（支持在所有可以插入网页链接的位置）</span
          >
        </div>
        <div class="link-title" v-if="h5ShareType == 1">
          文字+链接<span class="link-tip"
            >（可发送到群聊/私聊位置，邀请作答）</span
          >
        </div>
        <div class="link-title" v-if="h5ShareType == 2">
          H5二维码
        </div>
        <div class="link-url" v-if="h5ShareType < 2" @click="copyH5Url">
          <div v-if="h5ShareType == 1">
            <div>{{ que.title }}</div>
            <div>出题人：{{ que.owner_name }}</div>
            <div>答题时间：{{ que.startDate }} 至 {{ que.endDate }}</div>
            <div class="link-icon">
              🔗 点击链接进入 #立吉答题 参与答题：
            </div>
          </div>
          <div>{{ h5_url }}{{ qid }}</div>
        </div>
      </div>
      <div v-if="h5ShareType == 2" class="code-box">
        <div class="code-content">
          <div class="detail-title">{{ que.title }}</div>
          <img
            class="detail-img"
            v-if="h5_qrcode"
            id="h5-qrbox"
            :src="h5_qrcode"
            alt=""
          />
          <van-loading v-else></van-loading>
          <div class="code-way">微信、企业微信扫码参与答题</div>
          <div class="h5-save-tip" v-if="!saveAble">长按图片保存</div>
        </div>
      </div>
      <div
        :class="[
          'code-tips',
          !enterprise_vip && h5ShareType == 2 ? 'padding' : ''
        ]"
      >
        <span class="active">注意：</span>[防作弊] [分享增加答题次数]
        功能在H5版本中不生效。
      </div>
    </template>
    <template v-if="tab_current == 3">
      <div class="share-box">
        <div class="public-box">
          <div class="t">
            <div class="title">AppID:</div>
            <div class="bg-text">{{ APPID }}</div>
          </div>
          <div
            class="public-btn"
            style="margin-bottom:30px"
            v-clipboard:copy="APPID"
            v-clipboard:success="copySuccess"
          >
            复制
          </div>
          <div class="t title">小程序路径：</div>
          <div class="t bg-text">
            <template v-if="unionid">
              /pages/homepage/homepage?unionid={{ unionid }}
            </template>
            <template v-else>
              {{ wxUrl + qid }}
            </template>
          </div>
          <div
            class="public-btn"
            v-clipboard:copy="wxUrl + qid"
            v-clipboard:success="copySuccess"
          >
            复制
          </div>
          <div class="tip">
            支持嵌入到公众号：文章、菜单栏、自动回复里；
            或者配置到其他小程序里插入答题活动入口；
            填写上方路径即可正确跳转，<label
              class="themeColor pointer"
              @click="toWebview"
              >点击查看详细操作步骤</label
            >
          </div>
        </div>
        <div class="censor-desc fix">
          如有问题，请<button class="themeColor pointer" @click="handleContact">
            联系客服
          </button>
        </div>
      </div>
    </template>
    <div id="footer" ref="footer" v-if="tab_current <= 1">
      <div class="change-types">
        <div
          @click="changeCardType(0)"
          :class="['types-item', { active: card_type == 0 }]"
          v-if="tab_current == 1"
        >
          样式
        </div>
        <div
          @click="changeCardType(1)"
          :class="['types-item', { active: card_type == 1 }]"
          v-if="tab_current == 1 || tab_current == 0"
        >
          颜色
        </div>
        <div
          @click="changeCardType(2)"
          :class="['types-item', { active: card_type == 2 }]"
          v-if="!unionid"
        >
          二维码形状
        </div>
        <div
          @click="changeCardType(3)"
          :class="['types-item', { active: card_type == 3 }]"
          v-if="
            (que.is_owner && unionid) ||
              (!unionid && (que.is_admin || que.is_owner))
          "
        >
          自定义logo
        </div>
      </div>

      <div
        class="footer-tab"
        :class="{ padmore: !saveAble }"
        v-if="card_type == 0"
      >
        <div
          v-for="(item, index) in tabImgs"
          :key="item"
          :class="['tab-current']"
          @click="changeTab(index)"
        >
          <img class="bg" :src="item" />
          <img
            v-if="tabIndex == index"
            class="checked-icon-bg"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-11-10/7982faba3acef72d7d1e6dcf4f6ba277.svg"
            mode="aspectFill"
          />
        </div>
      </div>

      <div
        v-if="card_type == 1"
        class="color-group"
        :class="{ padmore: !saveAble }"
      >
        <div
          class="color-item"
          v-if="tab_current == 0"
          @click="changeColor(-1)"
        >
          <img
            class="clear-bg"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-05-15/b5b8295635e10cb2e4292561b2032819.png"
            mode="as"
          />
          <div v-if="line_color_index == -1" class="checked-icon">
            <img
              class="checked-icon-bg"
              src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-11-10/7982faba3acef72d7d1e6dcf4f6ba277.svg"
              mode="aspectFill"
            />
          </div>
        </div>
        <div
          class="color-item"
          v-for="(item, index) in colorLists"
          :key="item.bg"
          :style="`background: ${item.bg}`"
          @click="changeColor(index, item.bg)"
        >
          <div
            v-if="
              (tab_current == 0 && line_color_index == index) ||
                (tab_current == 1 && bg_color_index == index)
            "
            class="checked-icon"
          >
            <img
              class="checked-icon-bg"
              src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-11-10/7982faba3acef72d7d1e6dcf4f6ba277.svg"
              mode="aspectFill"
            />
          </div>
        </div>
      </div>

      <div
        class="code-types"
        :class="{ padmore: !saveAble }"
        v-if="card_type == 2"
      >
        <div
          :class="['code-item', { active: codeType == 1 }]"
          @click="changeCodeType(1)"
        >
          <img
            class="mini-icon"
            :src="codeType == 1 ? qrIcon[1] : qrIcon[0]"
            mode=""
          />
          圆形·小程序码
          <img
            v-if="codeType == 1"
            class="selected-icon"
            :src="selectedIcon"
            mode=""
          />
        </div>
        <div
          :class="['code-item', 'r', { active: codeType == 2 }]"
          @click="changeCodeType(2)"
        >
          <img
            class="mini-icon"
            :src="codeType == 2 ? qrIcon[3] : qrIcon[2]"
            mode=""
          />
          方形·二维码
          <img
            v-if="codeType == 2"
            class="selected-icon"
            :src="selectedIcon"
            mode=""
          />
        </div>
      </div>

      <div
        class="logo-set"
        :class="{ padmore: !saveAble }"
        v-if="(que.is_owner || que.is_admin) && card_type == 3"
      >
        <img
          class="vip-tag"
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220729/4f91a85daa195a30cda2a42cb24d320d.svg"
          mode=""
        />
        建议尺寸60*60：
        <div class="logo-upload">
          <template v-if="logo || personal_logo">
            <img
              class="logo-pic"
              mode="aspectFill"
              @click="prevImg(logo || personal_logo)"
              :src="logo || personal_logo"
            />
            <div
              class="logo-pic-cover"
              @click="enterprise_vip ? '' : uploadTip()"
              v-if="(logo || personal_logo) && !enterprise_vip"
            >
              恢展<br />复示
            </div>
            <div class="logo-delete-icon" v-else @click.stop="deleteLogo">
              删除
            </div>
          </template>
          <div
            v-else
            class="upload-wrap"
            @click="enterprise_vip ? '' : uploadTip()"
          >
            <van-uploader
              class="custom-uploader"
              :deletable="false"
              :before-read="beforeRead"
              :after-read="afterRead"
              :max-count="1"
              accept="image/png, image/jpeg"
              v-model="imgList"
            >
              <div class="upload-btn">
                <img
                  class="pic-icon"
                  src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220323/8e0a3abbd950f9f88aa1cf199177fb5f.svg"
                  mode="aspectFill"
                  alt=""
                />
                <span>logo</span>
              </div>
            </van-uploader>
            <div v-if="!enterprise_vip" class="upload-wrap-cover"></div>
          </div>
        </div>
      </div>

      <div class="code-btn save-btn" @click="saveImg" v-if="saveAble">
        下载图片
      </div>
    </div>
    <div v-if="tab_current == 2" class="nopadding" id="footer">
      <div
        v-if="que.is_owner && !enterprise_vip"
        class="top-tips"
        @click="toVip"
      >
        <div class="l">
          <img
            class="icon"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220729/4f91a85daa195a30cda2a42cb24d320d.svg"
            alt=""
          />
          <span>基础版H5仅展示活动详情，无法参与答题</span>
        </div>
        <div class="r">去升级<span class="arrow">></span></div>
      </div>
      <div class="code-types">
        <div
          :class="['code-item', { active: h5ShareType == 0 }]"
          @click="changeH5Share(0)"
        >
          H5链接
          <img
            v-if="h5ShareType == 0"
            class="selected-icon"
            :src="selectedIcon"
            alt=""
          />
        </div>
        <div
          :class="['code-item', 'r', { active: h5ShareType == 1 }]"
          @click="changeH5Share(1)"
        >
          文字+链接
          <img
            v-if="h5ShareType == 1"
            class="selected-icon"
            :src="selectedIcon"
            alt=""
          />
        </div>
        <div
          :class="['code-item', 'r', { active: h5ShareType == 2 }]"
          @click="changeH5Share(2)"
        >
          图文二维码
          <img
            v-if="h5ShareType == 2"
            class="selected-icon"
            :src="selectedIcon"
            alt=""
          />
        </div>
      </div>
      <div
        v-if="h5ShareType < 2 || saveAble"
        class="code-btn save-btn"
        @click="h5ShareType < 2 ? copyH5Url() : saveToPhone()"
      >
        {{ h5ShareType < 2 ? "复制" : "下载图片" }}
      </div>
    </div>
    <ContactImg :visible="showContact" @hideVisible="handleContact()" />
  </div>
</template>
<script>
import { Toast, ImagePreview, Dialog } from "vant";
import { shareSetting, default_banner } from "@/utils/config";
import ContactImg from "@/components/contactImg";
import html2canvas from "html2canvas";
import api from "@/utils/api";
import uploadHttp from "@/utils/picOnly";
import * as imageConversion from "image-conversion";
import questionOnly from "@/utils/questionOnly";

import {
  showServiceAble,
  isMobile,
  isWeixin,
  getQrcodeFn,
  getToken,
  vipClick,
  jumpVip,
  formatDate
} from "@/utils/common";

export default {
  data() {
    return {
      b_width: "",
      b_height: "",
      showLoading: true,
      middleHeight: "",
      imgList: [],
      isWeixin: isWeixin(),
      isMobile: isMobile(),
      saveAble: !isMobile() && !isWeixin(),
      showContact: false,
      APPID: "wx2aed548e27e28de9",
      qid: "66693b8cc9328450f4592999",
      wxUrl: `/pages/detail/detail?qid=`,
      h5ShareType: 1,
      enterprise_vip: 0,
      tab_current: 0, // 顶部tab切换
      codeType: 1, // 1 圆码 2、方码
      tabIndex: 0, // 分享图index
      card_type: 1, // footer tab切换
      appletImg: "",
      qrcode: {},
      img: "",
      h5_url: `https://m.xiaoxiaodati.com/normal/detail?qid=`,
      que: {},
      imgs: [],
      hidePicArr: { hide_offical: 1 },
      logo: "",
      customcolor: "#1890FF",
      unionid: "",
      personal_logo: "",
      h5_qrcode: "",
      h5Url: "",
      line_color_index: 4,
      bg_color_index: 0,
      tabs: shareSetting.tabs,
      tabImgs: shareSetting.tabImgs,
      tabBgImgs: shareSetting.tabBgImgs,
      selectedIcon: shareSetting.selectedIcon,
      colorLists: shareSetting.colorLists,
      qrIcon: shareSetting.qrIcon,
      default_banner: default_banner,
      prurl: ""
    };
  },
  methods: {
    toVip() {
      vipClick("h5_share_lead", "h5分享页引导", 1);
      localStorage.setItem(
        "shareTypeInfo",
        JSON.stringify({
          type: this.tab_current,
          index: this.codeType
        })
      );
      jumpVip(this);
    },
    uploadTip() {
      if (this.que.is_owner) {
        Dialog.confirm({
          message: "仅高级版用户可以使用「自定义logo」功能以及其他高级版权益。",
          confirmButtonColor: "#1890FF",
          confirmButtonText: "立即前往",
          cancelButtonText: "我知道了"
        }).then(() => {
          vipClick("diy_logo", "自定义logo", 1);
          localStorage.setItem(
            "shareTypeInfo",
            JSON.stringify({
              type: this.tab_current,
              index: this.codeType
            })
          );
          jumpVip(this);
        });
      } else {
        Dialog.alert({
          title: "",
          message:
            "仅高级版用户可以使用「自定义logo」功能以及其他高级版权益。请联系出题人升级后使用。",
          confirmButtonColor: "#1890ff",
          confirmButtonText: "我知道了"
        });
      }
    },
    saveToPhone() {
      this.canvasPaint(1);
    },
    deleteLogo() {
      this.imgList = [];
      this.logo = "";
      this.changeLogo(1, "");
      setTimeout(() => {
        this.canvasPaint();
      }, 100);
    },
    bannerLoad(e) {
      this.b_width = e.target.width;
      this.b_height = e.target.height;
      setTimeout(() => {
        this.handleBannerCalc();
      }, 1000);
    },
    handleBannerCalc() {
      let tabIndex = this.tabIndex;
      const tmp_h = tabIndex > 1 ? 152 : 175,
        tmp_w = tabIndex > 1 ? 272 : 315;
      let { b_height, b_width } = this;
      if (b_height / b_width > tmp_h / tmp_w) {
        b_height = (tmp_w * b_height) / b_width;
        b_width = tmp_w;
      } else {
        b_width = (tmp_h * b_width) / b_height;
        b_height = tmp_h;
      }
    },
    calculateMiddleHeight() {
      const footerHeight = this.$el.querySelector("#footer").offsetHeight;
      this.middleHeight = window.innerHeight - 44 - footerHeight;
    },
    changeHeadTab(tab_current) {
      if (tab_current < 2) {
        this.showLoading = true;
        this.$nextTick(this.calculateMiddleHeight);
        this.card_type = tab_current == 0 ? 1 : 0;
      }
      this.tab_current = tab_current;
      this.changeDom();
    },
    changeDom() {
      let tab_current = this.tab_current;
      let codeType = this.codeType;
      if (tab_current == 0) {
        // 分享码
        if (codeType == 1) {
          // 从方码切为圆码
          if (this.qrcode.code4) {
            setTimeout(() => {
              this.canvasPaint();
            }, 100);
          } else {
            this.getQuesQrCode(4);
          }
        } else if (codeType == 2) {
          // 从圆码切为方码
          if (this.qrcode.code5) {
            setTimeout(() => {
              this.canvasPaint();
            }, 100);
          } else {
            this.getQuesQrCode(5);
          }
        }
      } else if (tab_current == 1) {
        // 分享图
        if (codeType == 1) {
          // 从方码切为圆码
          if (this.qrcode.code1) {
            setTimeout(() => {
              this.canvasPaint();
            }, 100);
          } else {
            this.getQuesQrCode(1);
          }
        } else if (codeType == 2) {
          // 从圆码切为方码
          if (this.qrcode.code2) {
            setTimeout(() => {
              this.canvasPaint();
            }, 100);
          } else {
            this.getQuesQrCode(2);
          }
        }
      } else if (tab_current == 2) {
        // h5链接
        if (!this.h5_qrcode) {
          this.getQuesQrCode(3);
        }
      }
    },
    prevImg(val) {
      ImagePreview({
        images: [val],
        showIndex: false,
        loop: false,
        startPosition: 0
      });
      // 预览logo
    },
    beforeRead(file) {
      this.$store.commit("changeLoading", { status: true, text: "图片上传中" });
      const isLt1M = (file.size / 1024 / 1024) * 10 < 5;
      if (!isLt1M) {
        let myImg = new Promise(resolve => {
          // 压缩到500KB,这里的500就是要压缩的大小,可自定义
          imageConversion.compressAccurately(file, 500).then(res => {
            resolve(res);
          });
        });
        return myImg;
      }
      return true;
    },
    afterRead(file) {
      var url = api.question.upload;
      let formData = new window.FormData();
      formData.append("file", file.file);
      formData.append("access_token", getToken());
      try {
        uploadHttp.post(url, formData).then(res => {
          this.logo = res.data.urls[0];
          this.changeLogo(0, res.data.urls[0]);
          setTimeout(() => {
            this.canvasPaint();
          }, 100);
          this.$store.commit("changeLoading", { status: false });
        });
      } catch (e) {
        this.$store.commit("changeLoading", { status: false });
      }
    },
    saveImg() {
      this.downloadBase64Image(this.prurl);
    },
    canvasPaint(h5) {
      // this.$store.commit("changeLoading", { status: true, text: "" });
      window.pageYoffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      const domObj = document.querySelector(
        h5 ? "#h5-qrbox" : this.tab_current == 0 ? "#pic-box" : "#pic-box1"
      );
      let width = domObj.offsetWidth; //获取dom 宽度
      let height = domObj.offsetHeight; //获取dom 高度
      let canvas = document.createElement("canvas"); //创建一个canvas节点
      const scale = 2; //定义任意放大倍数 支持小数
      canvas.width = width * scale; //定义canvas 宽度 * 缩放
      canvas.height = height * scale; //定义canvas高度 *缩放
      let context = canvas.getContext("2d");
      // 【重要】关闭抗锯齿
      context.mozImageSmoothingEnabled = false;
      context.webkitImageSmoothingEnabled = false;
      context.msImageSmoothingEnabled = false;
      context.imageSmoothingEnabled = false;
      let opts = {
        // 注意：  allowTaint: true  和 useCORS: true 不能同时设置，两者只有一个起作用
        scale: scale, // 添加的scale 参数
        canvas: canvas, //自定义 canvas
        allowTaint: true, // 允许污染，允许画布上有跨域图片 不建议使用 后面详细补充
        logging: true, //日志开关，便于查看html2canvas的内部执行流程
        width: width, //dom 原始宽度
        height: height,
        dpi: 300,
        useCORS: true, // 【重要】开启跨域配置
        letterRendering: true,
        ...(this.tab_current == 0 && this.line_color_index == -1
          ? { backgroundColor: null }
          : {})
      };
      html2canvas(domObj, opts).then(canvas => {
        // 在微信里,可长按保存或转发
        if (h5) {
          this.downloadBase64Image(canvas.toDataURL("image/png"));
        } else {
          this.prurl = canvas.toDataURL("image/png");
        }
        if (this.showLoading) this.showLoading = false;
      });
    },
    downloadBase64Image(base64Data) {
      // 创建一个 <a> 元素
      var linkElement = document.createElement("a");
      linkElement.href = base64Data;
      let title = this.que.title.replace(/\s+/g, "_");
      linkElement.download = title;
      // 在文档中添加该元素，并模拟点击
      document.body.appendChild(linkElement);
      linkElement.click();

      // 从文档中移除该元素
      document.body.removeChild(linkElement);
    },
    changeLogo(data_type, logo) {
      let data = {
        access_token: getToken(),
        qid: this.qid,
        ...(data_type == 1 ? {} : { url: logo }),
        data_type // 0：更换logo，1：移除logo
      };
      questionOnly.post("/xcx/ques/v1/logo/update", data).then(res => {
        if (res.sta == 0) {
        } else {
          Toast(res.msg || "请求失败");
        }
      });
    },
    changeCodeType(index) {
      // 切换圆码 | 方码
      this.codeType = index;
      this.changeDom();
    },
    changeColor(index) {
      let { tab_current, codeType } = this;
      if (tab_current == 0) {
        // 分享码
        if (codeType == 2) {
          // 如果是方码则不支持改颜色
          return Toast("只有圆形码支持更换颜色");
        }
      }
      if (tab_current == 0) {
        this.line_color_index = index;
        this.getQuesQrCode(4);
      } else {
        this.bg_color_index = index;
        this.changeDom();
      }
    },
    async handleContact() {
      let res = await showServiceAble();
      if (res) {
        this.showContact = !this.showContact;
      }
    },
    changeH5Share(val) {
      this.h5ShareType = val;
    },
    changeTab(index) {
      this.tabIndex = index;
      setTimeout(() => {
        this.canvasPaint();
      }, 100);
    },
    changeCardType(type) {
      let { tabIndex, tab_current, codeType } = this;
      if (type == 1) {
        // 跳转到改颜色v
        if (tab_current == 1 && tabIndex > 1) {
          return Toast("当前选中的分享图不支持更换背景颜色");
        }
        if (tab_current == 0 && codeType == 2) {
          return Toast("只有圆形码支持更换颜色");
        }
      }
      this.card_type = type;
    },
    // 复制H5链接
    copyH5Url() {
      let _this = this;
      let { h5_url, qid, que, h5ShareType, enterprise_vip } = this;
      if (!enterprise_vip && que.is_owner) {
        Dialog.confirm({
          message:
            "仅高级版用户可以使用「H5纯净版作答」功能以及其他高级版权益。继续复制仅支持展示详情页，无法参与作答。",
          confirmButtonText: "立即前往",
          cancelButtonText: "继续复制",
          confirmButtonColor: "#1890FF"
        })
          .then(() => {
            vipClick("h5_share_lead", "h5分享页引导", 1);
            localStorage.setItem(
              "shareTypeInfo",
              JSON.stringify({
                type: this.tab_current,
                index: this.codeType
              })
            );
            jumpVip(this);
          })
          .catch(() => {
            copyToClipboard();
          });
      } else {
        copyToClipboard();
      }
      function copyToClipboard() {
        let addText = `${que.title}\n出题人：${que.owner_name}\n答题时间：${que.startDate} 至 ${que.endDate}\n\n🔗 点击链接进入 #立吉答题 参与答题`;
        let content = h5_url + qid;
        _this.$copyText(h5ShareType == 1 ? addText + "\n" + content : content);
        Toast("复制成功");
      }
    },
    copyAppletUrl() {},
    toWebview() {
      localStorage.setItem(
        "shareTypeInfo",
        JSON.stringify({
          type: this.tab_current,
          index: this.codeType
        })
      );
      window.location.href =
        "https://mp.weixin.qq.com/s/zhDT4tynRaxosKdOLU1GPg";
    },
    toContact() {},
    copySuccess() {
      Toast("复制成功");
    },
    async getQuesQrCode(type) {
      let qid = this.qid;
      if (type == 3) {
        // h5链接二维码
        let code3 = await getQrcodeFn({
          qid,
          mode: 13,
          is_hyaline: 0,
          with_bg: 0
        });
        this.h5_qrcode = code3.url;
      }
      if (type != 3) this.showLoading = true;
      if (type == 1) {
        // 小程序圆码
        let code1 = await getQrcodeFn({
          qid,
          mode: 2,
          is_hyaline: 1,
          with_bg: 0
        });
        this.qrcode = {
          ...this.qrcode,
          code1: code1.url
        };
      }
      if (type == 2) {
        // 小程序方码
        let code2 = await getQrcodeFn({
          qid,
          mode: 1,
          is_hyaline: 1,
          with_bg: 0
        });
        this.qrcode = {
          ...this.qrcode,
          code2: code2.url
        };
      }
      if (type == 4) {
        // 分享码小程序码圆码
        let line_color = "";
        let with_bg = 1;
        if (this.line_color_index == -1) {
          with_bg = 0;
        } else {
          line_color = this.colorLists[this.line_color_index].rgbColor;
        }
        let code4 = await getQrcodeFn({
          qid,
          mode: 0,
          is_hyaline: 1,
          with_bg,
          ...(line_color ? { line_color } : {})
        });
        this.qrcode = {
          ...this.qrcode,
          code4: code4.url
        };
      }
      if (type == 5) {
        // 分享码小程序码方码
        let code5 = await getQrcodeFn({
          qid,
          mode: 1,
          is_hyaline: 1,
          with_bg: 1
        });
        this.qrcode = {
          ...this.qrcode,
          code5: code5.url
        };
      }
      if (type && type != 3) {
        setTimeout(() => {
          this.canvasPaint();
        }, 100);
      }
    },
    getDetail() {
      let data = {
        qid: this.qid,
        access_token: getToken(),
        xcx_version: "1.0.0",
        version_code: "1"
      };
      questionOnly.get("/xcx/ques/v1/detail/home", data).then(res => {
        if (res.sta == 0) {
          let que = res.data;
          que.startDate = que.t_start
            ? formatDate(
                new Date(que.t_start * 1000),
                "yyyy-MM-dd HH:mm",
                "sameYear"
              )
            : "";
          que.endDate = que.t_end
            ? formatDate(
                new Date(que.t_end * 1000),
                "yyyy-MM-dd HH:mm",
                "sameYear"
              )
            : "";
          this.qid = que.qid;
          this.logo = que.logo;
          this.enterprise_vip = que.enterprise_vip;
          this.que = que;
          let shareTypeInfo = localStorage.getItem("shareTypeInfo");
          if (shareTypeInfo) {
            shareTypeInfo = JSON.parse(shareTypeInfo) || {};
          }
          if (this.$route.query.type) {
            this.tab_current = shareTypeInfo
              ? shareTypeInfo.type * 1
              : this.$route.query.type * 1;
          }
          if (this.tab_current == 1) {
            this.card_type = 0;
          }
          if (this.tab_current < 2) {
            this.$nextTick(this.calculateMiddleHeight);
            window.addEventListener("resize", this.calculateMiddleHeight);
          }
          let type;
          if (this.tab_current == 0) {
            // 分享码
            let index = shareTypeInfo
              ? shareTypeInfo.index * 1
              : this.$route.query.index;
            this.codeType = index;
            type = index == 1 ? 4 : 5;
          } else if (this.tab_current == 1) {
            // 分享图
            type = 1;
          } else if (this.tab_current == 2) {
            // h5链接二维码
            type = 3;
          }
          this.getQuesQrCode(type);
          if (localStorage.getItem("shareTypeInfo")) {
            localStorage.removeItem("shareTypeInfo");
          }
          if (localStorage.getItem("que_share")) {
            localStorage.removeItem("que_share");
          }
        } else {
          Toast(res.msg || "请求失败");
        }
      });
    }
  },
  async mounted() {
    if (this.$route.query.qid) {
      this.qid = this.$route.query.qid;
      this.getDetail();
    }
  },
  components: { ContactImg }
};
</script>
<style lang="scss" scoped>
/deep/ .van-sticky--fixed {
  width: 100%;
  max-width: 500px;
  min-width: 320px;
  left: auto;
  right: auto;
}
.share-box {
  /* background: #ffffff; */
  padding: 0 0 15px;
  box-sizing: border-box;
  max-width: 500px;
  min-width: 320px;
  margin: 0 auto;
  position: relative;
  min-height: 100vh;
}
.code-box {
  padding: 0 15px 0;
  background: #fff;
}

.code-content {
  padding: 20px 0;
  text-align: center;
  background: #f8f8f8;
  border-radius: 8px;
}

.detail-title {
  font-size: 17px;
  font-weight: bold;
  line-height: 20px;
}

.detail-img {
  width: 160px;
  height: 160px;
  margin: 20px 0;
  border-radius: 4px;
}

.code-way {
  padding: 5px 10px;
  border: 1px dashed #cccccc;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  color: #999999;
  width: 205px;
  text-align: center;
  margin: 0 auto;
}

.code-tips {
  padding: 15px 15px 30px;
  font-size: 15px;
  font-weight: normal;
  line-height: 20px;
  color: #999999;
  background: #fff;
}
.code-tips.padding {
  padding-bottom: 170px;
}

.code-tips .active {
  color: #ff0000;
}

.censor-desc {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.6;
  font-size: 14px;
  color: #999;
  padding: 0 15px 40px;
}
.censor-desc.fix {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
.link-box {
  padding: 20px 15px 10px;
  background: #fff;
}

.link-title,
.code-title {
  font-size: 16px;
  font-weight: bold;
}

.link-tip {
  color: #999999;
  font-weight: initial;
  font-size: 14px;
}

.link-url {
  padding: 10px 15px;
  background: #f2f2f7;
  font-size: 15px;
  line-height: 20px;
  margin: 10px 0 0;
  border-radius: 4px;
  color: #3d3d3d;
}

.link-btn,
.code-btn {
  height: 43px;
  line-height: 43px;
  font-size: 15px;
  color: #ffffff;
  text-align: center;
  background: #1890ff;
  border-radius: 4px;
}

.save-btn {
  margin: 15px 15px 10px;
  cursor: pointer;
}

.public-box {
  padding: 20px 15px;
  font-size: 15px;
  background-color: #ffffff;
}

.public-btn {
  width: 60px;
  height: 30px;
  color: #fff;
  background-color: #1890ff;
  border-radius: 5px;
  line-height: 30px;
  text-align: center;
  margin: 15px 0;
}

.tip {
  color: #999;
  word-break: break-all;
  font-size: 14px;
}

.mt40 {
  margin-top: 30px;
}

.title {
  font-weight: bold;
  margin-bottom: 5px;
}

.bg-text {
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  background: #f2f2f7;
  color: #3d3d3d;
  margin-top: 10px;
}
.top-tips {
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  background: #313238;
  color: #f0c89d;
  padding: 0 15px;
  border-radius: 10px 10px 0 0;
  cursor: pointer;
}

.top-tips .icon {
  width: 17px;
  height: 17px;
  margin-right: 5px;
}

.top-tips .l {
  display: flex;
  align-items: center;
}

.top-tips .r .arrow {
  position: relative;
  top: -1px;
  margin-left: 0;
}

.code-item {
  height: 32px;
  font-size: 14px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 5px 10px;
  border: 1px solid #eeeeee;
  color: #999999;
  position: relative;
  box-sizing: border-box;
  cursor: pointer;
}
.code-item .selected-icon {
  position: absolute;
  bottom: -1px;
  right: -7px;
  width: 15px;
  height: 15px;
  border: 1px solid #fff;
  border-radius: 50%;
}

.code-types .r {
  margin-left: 10px;
}

.code-item.active {
  background: #f3f9ff;
  color: #1890ff;
  border: 1px solid #1890ff;
}

.code-types {
  display: flex;
  align-items: center;
  margin: 15px 15px 15px;
  height: 47px;
  box-sizing: border-box;
}

.code-img {
  width: 300px;
  /* height: 849rpx; */
  margin: 30px auto 0;

  /* background-color: red; */
}

.code-img-image {
  margin: 0 auto;
  display: block;
  /* border: 1px solid red; */
  box-shadow: 0 0 11px #dddee1;
  /* width: 100%; */
  /* height: 100%; */
}
#footer {
  position: fixed;
  background-color: #fff;
  width: 100%;
  bottom: 0;
  z-index: 9;
  box-sizing: content-box;
  padding-bottom: env(safe-area-inset-bottom);
  border-radius: 10px 10px 0px 0px;
  padding-top: 10px;
  min-width: 320px;
  max-width: 500px;
  left: auto;
}
.link-icon {
  margin-top: 15px;
}
.change-types {
  display: flex;
  padding: 0 15px;
}

.types-item {
  position: relative;
  padding-bottom: 8px;
  margin-right: 30px;
  font-size: 14px;
  color: #999999;
  cursor: pointer;
}
.types-item.active {
  color: #262626;
}
.types-item.active:after {
  content: "";
  position: absolute;
  left: 50%;
  width: 20px;
  height: 2px;
  bottom: 0;
  transform: translateX(-50%);
  box-sizing: border-box;
  background: #262626;
  border-radius: 4px;
}
.color-item {
  width: 45px;
  height: 45px;
  min-width: 45px;
  border-radius: 50%;
  margin-right: 15px;
  display: inline-block;
  position: relative;
  cursor: pointer;
}
.color-item:last-child {
  margin-right: 30px;
}
.clear-bg {
  width: 45px;
  height: 45px;
  border-radius: 50%;
}

.checked-icon {
  position: absolute;
  /* width: 30rpx;
  height: 30rpx; */
  right: 0;
  top: 0;
  background-color: #ffffff;
  border-radius: 50%;
  border: 1px solid #ffffff;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checked-icon-bg {
  width: 15px;
  height: 15px;
  border: 1px solid #fff;
  border-radius: 50%;
}

.foot-icon {
  width: 15px;
  height: 17px;
  margin-right: 6px;
}
.color-group {
  margin: 15px 15px 15px 15px;
  white-space: nowrap;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
}
.sueeess-text {
  font-size: 9px;
  line-height: 15px;
  color: #999999;
}
.mini-icon {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  margin-right: 5px;
}
.cover-bg {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 8;
  top: 0;
  background-color: #f2f2f7;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 104px);
  font-size: 15px;
  color: #999999;
}
.nopadding {
  padding-top: 0 !important;
}
.footer-tab {
  display: flex;
  align-items: center;
  padding: 10px 15px 0;
  height: 80px;
  margin-bottom: 15px;
}
.footer-tab div {
  position: relative;
  margin-right: 15px;
}
.footer-tab .bg {
  display: block;
  width: 45px;
  height: 80px;
}
.footer-tab .checked-icon-bg {
  position: absolute;
  right: -7px;
  bottom: -7px;
}
.footer-tab .tab-current {
  color: #1890ff;
  cursor: pointer;
}
.preview-image {
  display: block;
  width: 335px;
  margin: 20px auto 85px;
  max-width: 345px;
}
.preview-image.shads {
  box-shadow: 0px 2px 10px 0 rgba(0, 0, 0, 0.1);
}
.logo-upload {
  width: 45px;
  height: 45px;
  border: 1px solid #cccccc;
  background: #f8f8f8;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  position: relative;
  cursor: pointer;
  font-size: 12px;
  color: #999999;
  box-sizing: border-box;
}
.logo-pic {
  width: 100%;
  height: 100%;
}
.logo-pic-cover {
  position: absolute;
  width: 45px;
  height: 45px;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 3;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 7px;
  box-sizing: border-box;
}

.vip-tag {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.pic-icon {
  width: 17px;
  height: 17px;
  cursor: pointer;
}

.logo-set {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin: 15px;
  height: 47px;
  box-sizing: border-box;
}
.btn-manage {
  text-align: center;
  font-size: 12px;
  color: #000;
  width: 25%;
  margin-bottom: 20px;
  cursor: pointer;
}
.btn-manage-ic {
  width: 24px;
  height: 24px;
  padding-bottom: 8px;
}
.button-white {
  background: #f5f6f7;
  color: #000;
  font-size: 15px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
}

.preview-img {
  background-size: cover;
  position: relative;
  width: 300px;
  min-width: 300px;
  height: 424px;
  box-sizing: border-box;
  text-align: left;
}
.preview-img.tall {
  height: 545px;
  border: 1px solid #eee;
}
.preview-cover {
  width: 300px;
  min-width: 300px;
  position: absolute;
  left: 0;
  top: 0;
}
.pre1-top {
  height: 103px;
  margin: 0 12px 12px;
  padding: 40px 12px 20px;
  z-index: 3;
  border-radius: 6.4px;
  box-sizing: border-box;
}
.pre0-top {
  margin: 0 12px;
  padding: 40px 12px 6px;
  z-index: 3;
  border-radius: 6.4px;
}
.pre0-title,
.pre1-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  height: 38px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.pre2-title {
  font-size: 18px;
  font-weight: 500;
  margin: 10px 40px 0;
  color: #3d3d3d;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.pre3-title {
  font-size: 24px;
  font-weight: 500;
  margin: 130px 40px 0;
  color: #3d3d3d;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}
.pre1-joined {
  font-size: 12px;
  color: #666666;
  margin-top: 14px;
}
.pre1-avatar,
.pre0-avatar,
.pre2-avatar,
.pre3-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-size: cover;
  object-fit: cover;
}
.pre0-avatar {
  width: 38px;
  height: 38px;
  border: 1px solid #fff;
}

.pre1-avatar {
  border: 1px solid #ffffff;
  box-sizing: border-box;
  margin-left: 24px;
  display: block;
}
.pre2-avatar,
.pre3-avatar {
  margin-left: 8px;
  margin-top: 18px;
}
.pre1-name {
  padding-top: 24px;
  margin-left: 8px;
  margin-right: 30px;
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.pre0-name {
  margin-left: 5px;
  font-size: 14px;
}
.pre0-name .inname {
  font-size: 12px;
}
.pre0-name .pre0-name .font500 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  width: 140px;
}
.pre2-name,
.pre3-name {
  margin: 18px 8px 0;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.pre1-qrcode {
  margin: 10px 0 0;
  text-align: center;
}
.pre1-qrcode,
.pre0-qrcode,
.pre2-qrcode,
.pre3-qrcode {
  position: relative;
}
// .pre2-qrcode, .pre3-qrcode {
//   top: -12px;
// }
.pre0-qrcode {
  width: 64px;
  height: 64px;
  overflow: hidden;
}
.pre1-qrcode-out {
  width: 160px;
  height: 160px;
  // margin-top: 30px;
}

.pre0-qrcode-out {
  width: 64px;
  height: 64px;
  margin: 0 0 0 0;
}
.pre2-qrcode-out {
  margin: 0 0 0 0;
}

.pre2-qrcode-out,
.pre3-qrcode-out {
  width: 60px;
  height: 60px;
}
.pre1-qrcode .code-type1 {
  left: 114px;
  top: 44px;
  width: 72px;
  height: 72px;
}
.pre1-qrcode .code-type2 {
  width: 27px;
  height: 27px;
  left: 138px;
  top: 68px;
}
.pre0-qrcode .code-type1 {
  left: 17px;
  top: 17px;
  width: 30px;
  height: 30px;
}
.pre0-qrcode .code-type2 {
  width: 13px;
  height: 13px;
  left: 27px;
  top: 27px;
}

.pre2-qrcode .code-type1 {
  left: 16px;
  top: 16px;
  width: 28px;
  height: 28px;
}
.pre2-qrcode .code-type2 {
  width: 13px;
  height: 13px;
  top: 23px;
  left: 23px;
}

.pre3-qrcode .code-type1 {
  left: 16px;
  top: 16px;
  width: 28px;
  height: 28px;
}
.pre3-qrcode .code-type2 {
  width: 13px;
  height: 13px;
  top: 23px;
  left: 23px;
}
.pre1-invite {
  font-size: 12px;
  color: #666666;
  text-align: center;
  margin-top: 14px;
}
.pre0-invite {
  margin: 66px 24px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pre0-footer,
.pre1-footer {
  padding: 0;
  line-height: initial;
  img {
    width: 16px;
    height: auto;
    margin-right: 4px;
    vertical-align: sub;
    position: relative;
    top: 1px;
  }
}
.pre1-footer {
  text-align: center;
  font-size: 12px;
  margin-top: 24px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pre0-footer {
  text-align: center;
  font-size: 12px;
  margin-top: 29px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pre2-footer,
.pre3-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 12px 0;
  font-size: 12px;
  position: absolute;
  bottom: 8px;
  right: 0;
  left: 0;
  .tip1 {
    color: #1890ff;
  }
  .tip2 {
    color: #666666;
    margin-top: 8px;
  }
}
.pre3-footer {
  // margin: 0 12px 0;
}

.pre0-banner {
  width: 254px;
  height: 142px;
  background-size: cover;
  display: block;
  margin: 10px auto 0;
  object-fit: cover;
}
.pre2-banner {
  width: 220px;
  height: 125px;
  background-size: cover;
  display: block;
  margin: 80px auto 0;
  object-fit: cover;
}
.curActive0-icon,
.curActive1-icon,
.curActive2-icon,
.curActive3-icon {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 30px;
  height: 30px;
  z-index: 3;
}
.curActive0-bg,
.curActive1-bg,
.curActive2-bg,
.curActive3-bg {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  z-index: 3;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2;
}
.curActive0-bg,
.curActive1-bg {
  top: 16px;
  bottom: 16px;
}
.curActive0-icon,
.curActive1-icon {
  bottom: 16px;
}
.load-bg-btn {
  height: 40px;
  font-size: 16px;
  margin: 0 24px;
  display: block;
  width: calc(100% - 48px);
}
.gzhfile {
  background: #fbfcfd;
  padding: 24px 24px 24px;
  border-radius: 4px;
}
.gzhfile-link {
  color: #999999;
  font-size: 14px;
  line-height: 22px;
}
.color-box {
  width: 281px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
}

.toggle-btn {
  line-height: 24px;
  font-size: 12px;
  color: #999999;
  display: inline-block;
  cursor: pointer;
}
.bg-imgs {
  min-width: 850px;
  background: #ffffff;
}
.code-imgs {
  min-width: 620px;
  background: #ffffff;
}
.preview-img-box {
  margin: 0 24px 24px;
  display: inline-block;
  position: fixed;
  left: 700%;
  top: 80px;
}
.paint-wrap {
  text-align: center;
  // padding-top: 20px;
}
.pic-box {
  width: 489px;
  height: 691px;
  text-align: center;
  border-radius: 4px;
  box-sizing: border-box;
  position: fixed;
  left: 700%;
  top: 80px;
  .pic-box-wrap {
    position: relative;
  }
  .cover-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    box-shadow: 0px 2px 10px 0 rgba(0, 0, 0, 0.1);
  }
  .cover-logo {
    position: absolute;
    width: 135px;
    height: 135px;
    min-height: 60px;
    display: inline-block;
    min-width: 60px;
    border-radius: 50%;
    object-fit: cover;
    left: 176px;
    top: 288px;
    background: #ffffff;
  }
  .cover-logo.active {
    left: 84px;
    top: 84px;
  }
  .square {
    width: 43px;
    height: 43px;
    left: 217px;
    top: 340px;
    border-radius: 4px;
  }
}
.custom-uploader {
  width: 45px;
  height: 45px;
  box-sizing: border-box;
}
/deep/ .custom-uploader .van-uploader__file {
  width: 45px;
  height: 45px;
}
/deep/ .van-uploader__preview-image {
  width: 45px;
  height: 45px;
}
.upload-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 45px;
  height: 45px;
  padding: 0;
  margin: 0;
}

.logo-delete-icon {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.42);
  border-radius: 0px 0px 2px 2px;
  color: #fff;
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  z-index: 2;
}
.logo-icon {
  width: 100%;
  height: 100%;
  display: block;
  background: #fff;
}
.logo {
  position: absolute;
  // background-image: url('https://cdn-xcx-qunsou.weiyoubot.cn/xcx/64ffdfc4e9839944810269f0/2023-09-12/5c01920184c74b1cab8f1749d972c918.jpeg');
  // background-position: center center;
  // background-size: cover;
  overflow: hidden;
  background: #fff;
  display: block;
}
.logo-icon {
  width: 100%;
  height: 100%;
  display: block;
  background: #fff;
}
.code-type1 {
  width: 72px;
  height: 72px;
  left: 70px;
  top: 44px;
  border-radius: 50%;
  background: #fff;
  .logo-icon {
    border-radius: 50%;
  }
}
.code-type2 {
  width: 28px;
  height: 28px;
  left: 93px;
  top: 68px;
}
.posterImg-box {
  margin: 0 auto;
  text-align: center;
  // margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.cover-bg {
  left: 0;
  right: 0;
  z-index: 8;
  top: 0;
  background-color: #f2f2f7;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 104px);
  font-size: 30rpx;
  color: #999999;
}
.van-tabs {
  z-index: 9;
  border-bottom: 1px solid #eeeeee;
}
.poster-img {
  object-fit: contain;
  max-height: 500px;
}
.read-text {
  height: 30px;
  line-height: 30px;
  color: #999;
  font-size: 14px;
}
.h5-save-tip {
  text-align: center;
  margin-top: 15px;
  font-size: 14px;
  color: #999999;
}
.upload-wrap {
  position: relative;
}
.upload-wrap-cover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3;
  bottom: 0;
}
.f12 {
  font-size: 12px;
}
.gray {
  color: #999999;
}
.iname {
  font-size: 14px;
  color: #fff;
  text-align: center;
  margin-top: 24px;
}
.font500 {
  font-weight: bold;
}
.padmore {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/share/sharebox.vue